import { CarrierCodeType } from '@/features/shipment/types';

export enum ExtensionInputType {
  string = 'System.String',
  boolean = 'System.Boolean'
}

export interface CarrierExtensionType {
  displayName: string,
  name: string,
  isRequired: boolean,
  value?: string | boolean,
  type: ExtensionInputType,
  order: number,
}

export interface CarrierAccountType {
  id: number,
  carrierCode: keyof typeof CarrierCodeType,
  countryCode: string,
  accountNumber: string,
  extensions: CarrierExtensionType[],
  isAvailable?: boolean,
}

export interface AvailableAccountsType {
  carrierCode: keyof typeof CarrierCodeType,
  extensions: CarrierExtensionType[]
}
